import Cookies from 'js-cookie'

import { removeTokenCookie } from 'bwax-ui/setTokenCookie'

export default function logout(dlc) {
  removeTokenCookie(dlc);
  location.reload();
}
